import { api } from '@/lib/api';
import type {
  CreateFormRequest,
  FormQuery,
  FormResponse,
  UpdateFormRequest,
} from '@troia-v3/types';

interface ChecklistTemplateListResponse {
  items: FormResponse[];
  total: number;
  page: number;
  totalPages: number;
}

/**
 * CRUD dos MODELOS de checklist sob `/api/checklists/templates`.
 *
 * Modelo de checklist é um `Form` com `type: 'checklist'`, mas NÃO usamos
 * `/api/forms`: aquelas rotas exigem permissão do módulo `forms`, enquanto o
 * item de menu "Checklists → Modelos" é liberado por `checklists:read`. Um
 * nível com Checklists habilitado e Formulários não tomava 403 e ficava sem
 * nenhum caminho para criar modelo — e sem modelo não existe checklist.
 *
 * O backend fecha todas estas rotas em `type: 'checklist'`, então não há como
 * usá-las para alcançar formulários comuns.
 */
export const checklistTemplatesApi = {
  async getAll(query?: FormQuery): Promise<ChecklistTemplateListResponse> {
    const response = await api.get('/checklists/templates', { params: query });
    return response.data.data;
  },

  async getById(id: string): Promise<FormResponse> {
    const response = await api.get(`/checklists/templates/${id}`);
    return response.data.data;
  },

  async create(data: CreateFormRequest): Promise<FormResponse> {
    const response = await api.post('/checklists/templates', data);
    return response.data.data;
  },

  async update(id: string, data: UpdateFormRequest): Promise<FormResponse> {
    const response = await api.put(`/checklists/templates/${id}`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/checklists/templates/${id}`);
  },
};
